/* eslint-disable no-param-reassign */

export default (ctx, x, y, scale, rotate, r, g, b, a) => {
  ctx.save();
  ctx.scale(scale, scale);
  ctx.translate(x, y);
  ctx.rotate((rotate / 180) * Math.PI);
  ctx.strokeStyle = `rgba(${r},${g},${b},${a})`;
  ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.save();
  ctx.beginPath();
  ctx.arc(2.96, 93.01, 2.68, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(35.86, 0);
  ctx.translate(35.82996471720434, 35.4099872618134);
  ctx.arc(0, 0, 35.41, -Math.PI / 2, -Math.PI, true);
  ctx.translate(-35.82996471720434, -35.4099872618134);
  ctx.lineTo(0.42, 83.84);
  ctx.lineTo(0.42, 83.84);
  ctx.translate(2.9699999999999998, 83.84);
  ctx.arc(0, 0, 2.55, Math.PI, 0, true);
  ctx.translate(-2.9699999999999998, -83.84);
  ctx.lineTo(5.52, 34.51);
  ctx.translate(35.80701038156426, 35.397131414740066);
  ctx.arc(0, 0, 30.3, -3.112310204492622, -Math.PI / 2, false);
  ctx.translate(-35.80701038156426, -35.397131414740066);
  ctx.bezierCurveTo(53.16, 5.61, 66.07, 19.57, 66, 36);
  ctx.lineTo(66, 78.84);
  ctx.bezierCurveTo(66, 79.84, 66, 80.77000000000001, 66, 81.71000000000001);
  ctx.bezierCurveTo(66.09, 84.63000000000001, 66.46, 88.02000000000001, 64.77, 90.62);
  ctx.translate(57.76876331231304, 85.79997045206296);
  ctx.arc(0, 0, 8.5, 0.602934880762666, 1.168089355082154, false);
  ctx.translate(-57.76876331231304, -85.79997045206296);
  ctx.translate(59.09895670157228, 89.4558403347353);
  ctx.arc(0, 0, 4.62, 1.1228379501125336, 2.369173330630956, false);
  ctx.translate(-59.09895670157228, -89.4558403347353);
  ctx.bezierCurveTo(
    54.28999999999999,
    91.08000000000001,
    52.25999999999999,
    88.87,
    48.379999999999995,
    88.87,
  );
  ctx.bezierCurveTo(44.5, 88.87, 42.47, 91.08, 40.989999999999995, 92.68);
  ctx.bezierCurveTo(39.50999999999999, 94.28000000000002, 39, 94.89, 37.46, 94.94);
  ctx.bezierCurveTo(35.92, 94.99, 35.160000000000004, 94.22, 33.84, 92.73);
  ctx.bezierCurveTo(
    32.35,
    91.12,
    30.310000000000002,
    88.91000000000001,
    26.440000000000005,
    88.91000000000001,
  );
  ctx.bezierCurveTo(
    22.570000000000007,
    88.91000000000001,
    20.530000000000005,
    91.12,
    19.040000000000006,
    92.72000000000001,
  );
  ctx.translate(11.086344299317192, 85.89579594421477);
  ctx.arc(0, 0, 10.48, 0.7091178244184306, 1.0009876498336023, false);
  ctx.translate(-11.086344299317192, -85.89579594421477);
  ctx.translate(18.02232622618861, 97.0390815961559);
  ctx.arc(0, 0, 2.65, -2.0758983079682674, -3.603470069001091, true);
  ctx.translate(-18.02232622618861, -97.0390815961559);
  ctx.lineTo(15.770000000000005, 98.34000000000002);
  ctx.translate(18.01733987775227, 96.84351629682632);
  ctx.arc(0, 0, 2.7, 2.5541271483926824, 0.9761153954775874, true);
  ctx.translate(-18.01733987775227, -96.84351629682632);
  ctx.lineTo(19.530000000000005, 99.08000000000001);
  ctx.translate(12.752849083315642, 88.11540582363013);
  ctx.arc(0, 0, 12.89, 1.0171784756306999, 0.6819422894878308, true);
  ctx.translate(-12.752849083315642, -88.11540582363013);
  ctx.bezierCurveTo(24.12, 94.72, 24.83, 94, 26.39, 94);
  ctx.bezierCurveTo(27.950000000000003, 94, 28.69, 94.71, 30.01, 96.21);
  ctx.bezierCurveTo(
    31.490000000000002,
    97.82,
    33.53,
    100.02999999999999,
    37.410000000000004,
    100.02999999999999,
  );
  ctx.bezierCurveTo(
    41.290000000000006,
    100.02999999999999,
    43.32000000000001,
    97.82,
    44.800000000000004,
    96.21,
  );
  ctx.bezierCurveTo(46.28, 94.6, 46.87, 94, 48.42, 94);
  ctx.bezierCurveTo(49.970000000000006, 94, 50.730000000000004, 94.71, 52.04, 96.21);
  ctx.lineTo(53.31, 97.47);
  ctx.bezierCurveTo(59.260000000000005, 102.83, 68.31, 97.47, 70.41, 90.87);
  ctx.translate(47.795634279784366, 85.21787092571866);
  ctx.arc(0, 0, 23.31, 0.24491780111544495, -0.06258357080298185, true);
  ctx.translate(-47.795634279784366, -85.21787092571866);
  ctx.lineTo(71.06, 36);
  ctx.bezierCurveTo(71.06, 16.7, 55.870000000000005, 0.46000000000000085, 36.57, 0);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(26.28, 39.52, 4.01, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(54.16, 39.13, 4.01, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(53.68, 110.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.translate(-74.71, 75.41);
  ctx.rotate(-0.7853981633974483);
  ctx.beginPath();
  ctx.arc(53.68, 127.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(28.18, 110.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.translate(-82.18, 57.38);
  ctx.rotate(-0.7853981633974483);
  ctx.beginPath();
  ctx.arc(28.18, 127.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(2.68, 110.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(2.68, 127.89, 2.68, 0, 6.283185307179586);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
